<app-menu [menuModuleEnum]='menuModuleEnum' [menuFunctionalityEnum]='menuFunctionalityEnum'></app-menu>

<div class="container-body">
    <h1>Unidades de Saúde</h1>
    <div class="white-body">
        <a mat-button class="btn-primary add-user" routerLink="/consulting/health-unit/register"><mat-icon
                aria-hidden="false" aria-label="Plus">add</mat-icon> Cadastrar unidade</a>
        <div class="filters">
            <div class="row">
                <div class="col-12 col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-icon matPrefix class="my-icon">search</mat-icon>
                        <mat-label>Pesquisar</mat-label>
                        <input matInput type="text" id="searchText" name="searchText" [(ngModel)]="searchText"
                            (keyup)="onKeySearch($event)">
                    </mat-form-field>
                </div>
                <div class="col-12 col-md-4">
                    <mat-form-field appearance="outline">
                        <mat-label>Grupo da unidade de Saude</mat-label>
                        <mat-select [(ngModel)]="idHealthUnitGroup" (selectionChange)="search()">
                            <mat-option value="">
                                Todos
                            </mat-option>
                            <mat-option *ngFor="let item of listHealthUnitGroup" value="{{item.idHealthUnitGroup}}">
                                {{item.nameHealthUnitGroup}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="card-list" *ngIf="listHealthUnit != null">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4" *ngFor="let item of listHealthUnit">
                    <div class="card-item">
                        <div class="infos">
                            <span class="primary">{{item.healthUnitName}}</span>
                            <span class="secundary">{{item.healthUnitGroupName? item.healthUnitGroupName : "Não possui
                                grupo"}}</span>
                            <span class="secundary">{{item.idSocialOrganization? item.socialOrganizationName : "Não
                                possui OS"}}</span>
                            <span class="secundary">{{item.datetimeInclusion | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
                        </div>
                        <div class="actions">
                            <a><mat-icon aria-hidden="false" aria-label="Editar"
                                    [routerLink]="['/consulting/health-unit/register', {idHealthUnit: item.idHealthUnit}]">edit</mat-icon>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-empty-list *ngIf="listHealthUnit != undefined && listHealthUnit.length == 0"></app-empty-list>
    </div>

    <app-loading-list *ngIf="isLoading"></app-loading-list>
</div>